var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
export default function StripContentAccordion(props) {
    var fields = props.fields, children = props.children;
    var _a = useState([]), answerIndex = _a[0], setAnswerIndex = _a[1];
    useEffect(function () {
        var arr = [];
        for (var i = 0; i < children.length; i++) {
            if (children[i].fields && children[i].fields.openByDefault) {
                arr.push(i);
                if (!fields.multipleItemsAtOnce) {
                    break;
                }
            }
        }
        setAnswerIndex(arr);
    }, []);
    var setActiveAnswer = function (i) {
        if (answerIndex.includes(i)) {
            var arr = fields.multipleItemsAtOnce ? answerIndex.filter(function (item) { return item !== i; }) : [];
            setAnswerIndex(arr);
        }
        else {
            setAnswerIndex(fields.multipleItemsAtOnce ? function (prevValues) { return __spreadArray(__spreadArray([], prevValues, true), [i], false); } : [i]);
        }
    };
    return (React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-content-accordion container-fluid position-relative component mb-4 text-moss  top-margin-none bottom-margin-none top-padding-none bottom-padding-none", itemScope: true, itemType: "https://schema.org/ItemList" },
        React.createElement("div", { className: "row justify-content-center" },
            React.createElement("div", { className: "col col-lg-8 intro-text-row" },
                fields.title &&
                    React.createElement("h3", { className: "h5 fw-bold", itemProp: "name" }, fields.title),
                fields.content &&
                    React.createElement("div", { className: "content-accordion-container-text", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" }))),
        React.createElement("div", { className: "row justify-content-center" },
            React.createElement("div", { className: "col col-lg-8 intro-text-row" }, children && children.length > 0 && children.map(function (item, index) {
                return (React.createElement("div", { className: "content-accordion-item " + (answerIndex.includes(index) ? "expanded" : "compact"), key: index, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/Thing" },
                    React.createElement("div", { className: "content-accordion-header", onClick: function () { return setActiveAnswer(index); }, title: "Show Content" }, item.fields.title &&
                        React.createElement("h2", { className: "content-accordion-title", itemProp: "name" }, item.fields.title)),
                    item.fields.content &&
                        React.createElement("div", { className: "content-accordion-body", dangerouslySetInnerHTML: { __html: item.fields.content }, itemProp: "description" })));
            })))));
}
